export default __webpack_public_path__ + "static/marketing-dc778a05ec14233e57a8cbb6f629f041.webp";